<template>
  <div :class="['list', 'calendar-list'].includes(type) ? 'pt-0' : 'pt-3'"
       class="skeleton-wrapper"
       data-cy="skeleton-loader"
  >
    <div v-for="skeleton in skeletons"
         :key="skeleton"
         :class="skeletonClasses"
    >
      <div v-if="type === 'list'" class="d-flex align-items-center w-100 skeleton-border">
        <div class="w-auto">
          <b-skeleton type="avatar"
                      class="mr-2 b-skeleton-avatar"
                      height="36px"
                      width="36px"
          />
        </div>
        <div class="w-100">
          <b-skeleton width="60%" height="16px" />
          <b-skeleton width="80%" height="16px" />
        </div>
      </div>
      <div v-if="type === 'news'">
        <b-card>
          <b-skeleton width="60%"
                      class="mr-auto mb-2"
                      height="24px"
          />
          <b-skeleton width="40%"
                      class="mr-auto mb-4"
                      height="16px"
          />
          <b-skeleton width="70%"
                      class="mr-auto mb-1"
                      height="16px"
          />
          <b-skeleton width="50%"
                      class="mr-auto mb-1"
                      height="16px"
          />
          <b-skeleton width="40%"
                      class="mr-auto mb-1"
                      height="16px"
          />
        </b-card>
      </div>
      <div v-if="type === 'chat'">
        <div class="d-flex">
          <div class="w-auto">
            <b-skeleton width="58px"
                        height="58px"
                        class="mr-2"
                        type="avatar"
            />
          </div>
          <div class="w-100">
            <b-skeleton height="16px" width="60%" />
            <b-skeleton height="16px" width="40%" />
            <b-skeleton height="16px" width="80%" />
          </div>
        </div>
        <hr />
      </div>
      <div v-if="type === 'calendar-list'" class="d-flex calendar-list-skeleton">
        <div class="date-skeleton pt-2 pr-2 mw-0 text-break">
          <div class="text-muted nano font-weight-light text-center">
            <b-skeleton width="100%"
                        height="20px"
                        class="mb-1"
            />
            <span class="date-range-separator mx-auto" />
            <b-skeleton width="100%"
                        height="20px"
                        class="mt-1"
            />
          </div>
        </div>
        <div class="d-flex flex-column w-100 skeleton-border">
          <b-skeleton width="50%" height="20px" />
          <div class="d-flex">
            <sdui-icon class="icon-user-teacher-o icon-16 nano d-block mr-2 text-muted" />
            <b-skeleton width="65%" height="16px" />
          </div>
          <div class="d-flex mt-1">
            <sdui-icon class="icon-description-16 icon-16 mr-2 text-muted" />
            <b-skeleton width="80%" height="16px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SduiSkeletons',
  components: {},
  props: {
    skeletons: {
      type: Number,
      default: 6,
    },

    type: {
      type: String,
      default: 'list',
      validator: function (value) {
        return ['news', 'chat', 'list', 'calendar-list'].includes(value)
      },
    },
  },

  computed: {
    skeletonClasses() {
      const classes = ['w-100']
      if (this.type !== 'calendar-list') classes.push('px-2')
      if (this.type === 'calendar-list' && this.skeletons > 1) classes.push('mb-3')
      return classes
    },
  },
}
</script>

<style scoped lang="scss">
.calendar-list-skeleton {
  .skeleton-border {
    border-radius: 0.75rem;
  }
  .date-skeleton {
    flex: 0 0 4.9em;
  }
  .date-range-separator {
    height: 15px;
    border-left: 2px $color-gray-100 dotted;
  }
}
</style>
